module.exports = __webpack_public_path__ + "templates/select-country.component.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/select-country/select-country.component.html
// module id = Q3s3
// module chunks = 1